/**
 * Email address validation for form fields.
 *
 * The API stores `email` as an unvalidated string, and it is the address the
 * practice's admin is reached at — a typo here is not a formatting problem, it
 * is an admin who never receives anything.
 *
 * The check is deliberately structural rather than exhaustive: local part,
 * a single `@`, a dotted domain, no whitespace. Chasing full RFC 5322 in a
 * regex rejects valid addresses more often than it catches invalid ones, and
 * only delivery proves an address real.
 */

const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/

export const REQUIRED_ERROR = 'Email is required.'
export const FORMAT_ERROR = 'Enter a valid email address.'

/** Returns an empty string when the address is usable, or the reason it is not. */
export const validateEmail = (value: string): string => {
  const trimmed = value.trim()
  if (!trimmed) {
    return REQUIRED_ERROR
  }
  return EMAIL_PATTERN.test(trimmed) ? '' : FORMAT_ERROR
}
